import React from 'react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-[#0F1216] text-white font-poppins flex flex-col items-center px-4 py-12">
      <h1 className="text-4xl md:text-5xl font-extrabold animate-gradient-text mb-8 text-center">
        About Eventzy
      </h1>
      <img
        src="/about.jpg"
        alt="Community gathering"
        className="w-full max-w-2xl rounded-lg shadow-lg mb-8 object-cover"
      />
      <div className="max-w-3xl text-center">
        <p className="text-lg md:text-xl text-gray-200 mb-6">
          Our mission is to make it easy for you to find and participate in local free events and never miss any event again. Whether you're looking to attend a workshop, event, program , or volunteer Eventzy has something for you.
        </p>
        <p className="text-lg md:text-xl text-gray-200">
          Support us by sharing free events and helping others discover amazing opportunities. Together, we can build a great community that thrives on shared experiences and mutual growth. Sharing is caring !
        </p>
      </div> 
    </div>
  );
};

export default AboutPage;